import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectDreamTeamCardData_MLB, selectPreSelectedCardId } from '../../../../store/showcase/showcase.selector';
import { setIsViewingNewSelection, setNewSelectionCardData } from '../../../../store/showcase/showcase.action';
import { fadeInUp } from '../../../../animations/Animations';
import { useSystemInitialization } from '../../../../hooks/useSystemInitialization';
import { motion } from 'framer-motion';

// styles
import {
    CardOptionsContainer
} from './CardOptions.styles';

// assets
import editIcon from '../../../../assets/system/icons/edit-icon.svg';

// components
import CardDisplayLarge from '../card-display-large/CardDisplayLarge';
import IconBtn from '../../../../components/btns/icon-btn/IconBtn';
import PrimaryBtn from '../../../../components/btns/primary-btn/PrimaryBtn';



export default function CardOptions() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const preSelectedCardId = useSelector(selectPreSelectedCardId);
    const dreamTeamCardData_MLB = useSelector(selectDreamTeamCardData_MLB);
    const positionHasCard = !!(dreamTeamCardData_MLB && dreamTeamCardData_MLB[preSelectedCardId]);
    const {
        checklistSportDefault: defaultSport,
        checklistYearDefault: defaultYear,
        checklistManufacturerDefault: defaultManufacturer
    } = useSystemInitialization();

    const handleEditImage = () => {
        const cardData = dreamTeamCardData_MLB[preSelectedCardId];
        dispatch(setIsViewingNewSelection(true));
        dispatch(setNewSelectionCardData(cardData));
        navigate('/selection-view', { state: { showcaseView: 'field' } });
    };

    return (
        <CardOptionsContainer>
            {positionHasCard ?
                <>
                    {dreamTeamCardData_MLB && dreamTeamCardData_MLB[preSelectedCardId] && (
                        <CardDisplayLarge
                            posIsDisplayed={false}
                            cardData={dreamTeamCardData_MLB[preSelectedCardId]}
                        />
                    )}
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <motion.div
                            onClick={handleEditImage}
                            initial="hidden"
                            animate="visible"
                            variants={fadeInUp}
                            custom={1 * 0.05}
                        >
                            <IconBtn variant="icon" size="md">
                                <img src={editIcon} alt="edit icon" />
                            </IconBtn>
                        </motion.div>
                    </div>
                </>
                :
                <motion.div
                    onClick={() => navigate(`/checklists/${defaultSport}/${defaultYear}/${defaultManufacturer}`)}
                    initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={3 * 0.05}
                >
                    <PrimaryBtn title={"ADD CARD"} />
                </motion.div>
            }
        </CardOptionsContainer>
    )
}
